import Vue from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library, config } from '@fortawesome/fontawesome-svg-core'
import {
  faBars as falBars,
  faCheck as falCheck,
  faChevronUp as falChevronUp,
  faChevronDown as falChevronDown,
  faChevronLeft as falChevronLeft,
  faChevronRight as falChevronRight,
  faChevronCircleLeft as falChevronCircleLeft,
  faChevronCircleRight as falChevronCircleRight,
  faCopy as falCopy,
  faGift as falGift,
  faFilePdf as falFilePdf,
  faEnvelope as falEnvelope,
  faExclamationTriangle as falExclamationTriangle,
  faInfoCircle as falInfoCircle,
  faMinus as falMinus,
  faPrint as falPrint,
  faPlus as falPlus,
  faQuestionCircle as falQuestionCircle,
  faShoppingBag as falShoppingBag,
  faTimes as falTimes,
  faCalendarPlus as falCalendarPlus,
  faPills as falPills,
  faExchange as falExchange,
  faUsdSquare as falUsdSquare
} from '@fortawesome/pro-light-svg-icons'
import {
  faArrowRight as farArrowRight,
  faBars as farBars,
  faCheck as farCheck,
  faCircle as farCircle,
  faChevronLeft as farChevronLeft,
  faChevronRight as farChevronRight,
  faEnvelope as farEnvelope,
  faPlus as farPlus,
  faPhoneAlt as farPhoneAlt,
  faSearchPlus as farSearchPlus,
  faShoppingBag as farShoppingBag,
  faSpinnerThird as farSpinner,
  faTimes as farTimes,
  faFlask as farFlask,
  faUsers as farUsers,
  faCalendar as farCalendar
} from '@fortawesome/pro-regular-svg-icons'
import {
  faCaretDown as fasCaretDown,
  faCheck as fasCheck,
  faCheckSquare as fasCheckSquare,
  faChevronDown as fasChevronDown,
  faCircle as fasCircle,
  faCheckCircle as fasCheckCircle,
  faUserCircle as fasUserCircle,
  faExclamationCircle as fasExclamationCircle,
  faSquare as fasSquare,
  faPlay as fasPlay,
  faPause as fasPause,
  faTag as fasTag
} from '@fortawesome/pro-solid-svg-icons'
import {
  faFacebookF,
  faTwitter,
  faInstagram,
  faTiktok,
  faYoutube
} from '@fortawesome/free-brands-svg-icons'

config.autoAddCss = false

library.add([
  faTiktok,
  falBars,
  falCheck,
  falChevronUp,
  falGift,
  falChevronDown,
  falChevronLeft,
  falChevronRight,
  falExclamationTriangle,
  falFilePdf,
  falEnvelope,
  falMinus,
  falPrint,
  falPlus,
  falQuestionCircle,
  falShoppingBag,
  falTimes,
  falCalendarPlus,
  falInfoCircle,
  falPills,
  falExchange,
  farBars,
  farCheck,
  farChevronLeft,
  farChevronRight,
  falChevronCircleLeft,
  falChevronCircleRight,
  fasPause,
  farCircle,
  falCopy,
  farSearchPlus,
  farShoppingBag,
  farSpinner,
  farPlus,
  farTimes,
  farArrowRight,
  farPhoneAlt,
  farEnvelope,
  fasCaretDown,
  fasCheck,
  fasCheckSquare,
  fasCheckCircle,
  fasChevronDown,
  fasCircle,
  fasPlay,
  fasTag,
  fasUserCircle,
  fasExclamationCircle,
  fasSquare,
  faFacebookF,
  faTwitter,
  faInstagram,
  falUsdSquare,
  faYoutube,
  farFlask,
  farUsers,
  farCalendar
])

Vue.component('fa', FontAwesomeIcon)
